import UltMeta, { Meta } from "./UltMeta/index";

class Project extends UltMeta {
    ALL = new Meta(0, "全部项目");
}

export const PROJECT = new Project();

class Role extends UltMeta {
    PURCHASE = new Meta(1, "采购商");
    SUPPLY = new Meta(2, "供应商");
    UNITETOSUPPLY = new Meta(3, "联合购销商与供应商");
    UNITETOPURCHASE = new Meta(4, "联合购销商与采购商");
}

export const ROLE = new Role();

/**
 * 货款统计
 */
class PaymentType extends UltMeta {
    INCOME = new Meta(2, "收入");
    EXPENSE = new Meta(1, "支出");
}

export const PAYMENT_TYPE = new PaymentType();
